import uuid from 'uuid/v4';

import { messagesApi } from '../../api';
import { API_URL } from '../../api/config';
import { usersRoles } from '../../constants';

export const SET_BUTTONS = 'MESSAGES:SET_BUTTONS';
export const RESET_BUTTONS = 'MESSAGES:RESET_BUTTONS';
export const SET_MESSAGES = 'MESSAGES:SET_ITEMS';
export const SET_NEW_MESSAGE = 'MESSAGES:SET_NEW_MESSAGE';
export const RESET_MESSAGES = 'MESSAGES:RESET_MESSAGES';
export const SET_IMAGE_PREVIEW = 'MESSAGES:SET_IMAGE_PREVIEW';
export const REMOVE_IMAGE_PREVIEW = 'MESSAGES:REMOVE_IMAGE_PREVIEW';
export const SET_TYPING = 'MESSAGES:SET_TYPING';
export const SET_OUTCOMING_LAST = 'MESSAGES:SET_OUTCOMING_LAST';
export const SET_MESSAGES_LOADING = 'MESSAGES:SET_LOADING';
export const SAVE_FEEDBACK = 'MESSAGES:SAVE_FEEDBACK';
export const SAVE_FETCHED_MESSAGES = 'MESSAGES:SAVE_FETCHED_MESSAGES';

const actions = {
  setMessages: {
    handle: SET_MESSAGES,
    event: 'messages',
  },
  setMessagesLoading: {
    type: SET_MESSAGES_LOADING,
  },
  subscribeExpertMessages: () => ({
    handle: SET_NEW_MESSAGE,
    func: (state, message) => {
      const currentDialogId = state.dialogs.currentDialogId;
      const { senderId } = state.meta.user;
      if (message && message.dialog_id === currentDialogId) {
        messagesApi.updateDialogMessages(currentDialogId, senderId);
      }
    },
    event: 'expert.message.added',
    leave: true
  }),
  subscribeBuyerMessages: {
    handle: SET_NEW_MESSAGE,
    event: 'addMessage',
  },
  unSubscribeMessages: {
    event: 'expert.message.added',
    leave: true,
  },
  subscribeButtons: {
    handle: SET_BUTTONS,
    event: 'buttons',
  },
  unSubscribeButtons: {
    event: 'buttons',
    leave: true,
  },
  messageChanged: {
    event: 'messageChanged',
    handle: SET_NEW_MESSAGE,
    leave: true,
  },
  resetMessages: {
    type: RESET_MESSAGES,
  },
  removeImagePreview: {
    type: REMOVE_IMAGE_PREVIEW,
  },
  setImagePreview: (url) => ({
    type: SET_IMAGE_PREVIEW,
    payload: url,
  }),
  saveFeedback: () => ({
    type: SAVE_FEEDBACK,
  }),
  setOutcomingLast: (isOutcomingLast) => (dispatch) => {
    dispatch({ type: SET_OUTCOMING_LAST, payload: isOutcomingLast });
  },
  setNewMessage: (text, message_uuid, sender_id, attachments = []) => ({
    type: SET_NEW_MESSAGE,
    result: {
      message_uuid,
      timestamp: new Date().valueOf(),
      content: {
        text,
        attachments,
      },
      sender: {
        sender_id,
        type_id: usersRoles.BUYER,
      },
    },
  }),
  setTyping: (bool) => ({
    type: SET_TYPING,
    payload: bool,
  }),
  addMessagesSubscription: () => (dispatch) => {
    dispatch(actions.setMessages);
    dispatch(actions.subscribeExpertMessages());
    dispatch(actions.subscribeBuyerMessages);
    dispatch(actions.subscribeButtons);
  },
  removeMessageSubscription: () => (dispatch) => {
    dispatch(actions.unSubscribeMessages);
    dispatch(actions.unSubscribeButtons);
  },
  fetchMessages: (dialogId) => (dispatch) => {
    dispatch(actions.resetMessages);
    dispatch(actions.setMessagesLoading);
    dispatch(actions.setMessages);
    messagesApi.getAllMessages(dialogId);
  },
  resyncMessages: (dialogId) => () => {
    if (!dialogId) {
      return;
    }
    messagesApi.getAllMessages(dialogId);
  },
  saveFetchedMessages: (messages, dialogId) => (dispatch) => {
    dispatch({
      type: SAVE_FETCHED_MESSAGES,
      payload: { messages, dialogId }
    });
  },
  setMessageFront:
    (text, senderId, message_uuid = uuid()) =>
      (dispatch) => {
        dispatch(actions.setNewMessage(text, message_uuid, senderId));
        dispatch(actions.setOutcomingLast(true));
      },
  sendMessage: (text, senderId, dialogId) => (dispatch) => {
    const message_uuid = uuid();
    dispatch(actions.setNewMessage(text, message_uuid, senderId));
    dispatch(actions.setTyping(false));
    dispatch(actions.setOutcomingLast(true));
    messagesApi.messageTyping(false);
    messagesApi.sendMessage(text, message_uuid, dialogId);
  },
  uploadFile: (file) => {
    return function (dispatch) {
      const formData = new FormData();
      formData.append('file', file);

      return fetch(`${API_URL}/upload/`, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((json) => dispatch(actions.setImagePreview(json[0])))
        .catch((error) => console.error(`Upload file error: ${error}`));
    };
  },
  sendMessageWithFile:
    (caption, image, dialogId) => (dispatch) => {
        const message_uuid = uuid();
        const urls = JSON.stringify([image]);
        if (urls) {
          messagesApi.sendMessageWithFile(caption, urls, message_uuid, dialogId);
          dispatch(actions.setOutcomingLast(true));
          dispatch(actions.setTyping(false));
          messagesApi.messageTyping(false, dialogId);
        }
      },
  typingChange: (value, currentDialogId) => (dispatch) => {
    dispatch(actions.setTyping(value));
    messagesApi.messageTyping(value, currentDialogId);
  },
  addBuyerChoice: (button, senderId, dialogId) => (dispatch) => {
    if (button.userReply) {
      const messageUUID = uuid();
      dispatch(actions.setMessageFront(button.userReply, senderId, messageUUID));
      messagesApi.addBuyerChoice({ ...button, messageUUID }, dialogId);
    } else {
      messagesApi.addBuyerChoice(button, dialogId);
    }
  },
  addLocationChoice: (dialogId, offer) => {
    messagesApi.addLocationChoice(dialogId, offer);
  },
  messageChangedSubscription: () => (dispatch) => {
    dispatch(actions.messageChanged);
  },
};

export default actions;
